import type {
  FooterConfig,
  LabelAfterPlacement,
  LabelBeforePlacement,
} from "./types";
import { normalizeMode } from "./display";

const STACK_MODES = ["logo-text", "icon-text", "avatar-text"] as const;

export interface ResolvedLabelPlacements {
  before: LabelBeforePlacement | null;
  after: LabelAfterPlacement | null;
}

function hasLabelAfter(config: FooterConfig): boolean {
  return Boolean(config.labelAfter?.trim());
}

export function resolveLabelPlacements(config: FooterConfig): ResolvedLabelPlacements {
  const hasBefore = Boolean(config.labelBefore?.trim());
  const hasAfter = hasLabelAfter(config);

  if (!hasBefore && !hasAfter) {
    return { before: null, after: null };
  }

  const layout = config.layout;
  const mode = normalizeMode(config);
  const stackDefault = layout === "stack" || (!layout && STACK_MODES.includes(mode as (typeof STACK_MODES)[number]));

  let before = config.labelBeforePlacement ?? null;
  let after = config.labelAfterPlacement ?? null;

  if (hasBefore && !before) {
    before = stackDefault && !hasAfter ? "top" : "left";
  }

  if (hasAfter && !after) {
    after = stackDefault && !hasBefore ? "bottom" : "right";
  }

  return {
    before: hasBefore ? before : null,
    after: hasAfter ? after : null,
  };
}

export function buildLinkClassNames(placements: ResolvedLabelPlacements): string {
  const classes = ["pf-link"];

  if (!placements.before && !placements.after) {
    return classes.join(" ");
  }

  classes.push("pf-link--composed");

  if (placements.before) {
    classes.push(`pf-link--before-${placements.before}`);
  }

  if (placements.after) {
    classes.push(`pf-link--after-${placements.after}`);
  }

  return classes.join(" ");
}
